// GroupSettings.tsx 파일 내부 또는 별도 파일에 정의

import React, {useEffect, useState} from "react";
import { Modal } from 'antd';
import * as Style from "../styles/GroupSettings.style";


import checkSVG from '../imgs/ic_check.svg'; 

interface ModeSelectionModalProps {
    open: boolean;
    currentMode: number;
    onSelect: (mode: number) => void;
    onClose: () => void;
}

const modes = [
    { value: 1, label: 'Mode 1: 시간표 제어' },
    { value: 2, label: 'Mode 2: 동작 센서 그룹 제어' },
    { value: 3, label: 'Mode 3: 동작 센서 소그룹 제어' },
    // { value: 4, label: 'Mode 4: (설명 4)' },
];

const ModeSelectionModal: React.FC<ModeSelectionModalProps> = ({ open, currentMode, onSelect, onClose }) => {
/*
    const [tempSelectedMode, setTempSelectedMode] = useState(currentMode);

    // 🔑 2. 모달이 열릴 때마다 currentMode로 임시 상태를 초기화
    useEffect(() => {
        if (open) {
            setTempSelectedMode(currentMode);
        }
    }, [open, currentMode]); 

    // 🔑 3. 항목 클릭 핸들러: 임시 상태만 업데이트
    const handleItemClick = (modeValue: number) => {
        setTempSelectedMode(modeValue);
    };    

    const handleConfirm = () => {
        onSelect(tempSelectedMode); // led_mode 상태 업데이트
        onClose();          // 모달 닫기
    };    
*/
    return (
        // 🔑 오버레이 배경 (클릭 시 모달 닫기)
        <Modal 
            // title="모드 선택"
            open={open}
            onCancel={onClose}
            footer={null}
            // footer={[
            //     <button key="cancel" onClick={onClose}>
            //         취소
            //     </button>,
            //     <button 
            //         key="confirm" 
            //         onClick={handleConfirm}
            //         // 임시 선택이 기존 모드와 같으면 비활성화
            //         disabled={tempSelectedMode === currentMode} 
            //     >
            //         선택 완료
            //     </button>,
            // ]} 
        >
            <Style.MotionModeSetListTitle>모드 선택</Style.MotionModeSetListTitle>

            <br></br><br></br>

            {/* 🔑 모드 선택 목록 */}           
            <Style.MotionModeSetListFrame>
                {modes.map((mode) => {
                    // 🔑 1. isSelected 변수 정의
                    const isSelected = currentMode === mode.value; 
                    const label = mode.label;
                    
                    return (
                        // 🔑 2. 최상위 Frame은 반복 구조만 담당합니다.
                        <Style.MotionModeSetListSelectFrame key={mode.value}>
                            
                            {/* 🔑 3. isSelected 상태에 따라 다른 JSX 렌더링 */}
                            {isSelected ? (
                                // 선택된 상태: Focus 스타일 + 체크 아이콘
                                <Style.MotionModeSetListSelectFocus
                                    onClick={() => onSelect(mode.value)} // 👈 클릭 이벤트 연결
                                >
                                    <Style.MotionModeSetLisSelect>
                                        {label}
                                    </Style.MotionModeSetLisSelect>
                                    <Style.MotionModeSetListSelectCheck
                                        $imgUrl={checkSVG} // checkSVG는 해당 파일에서 임포트되어 있어야 합니다.
                                    />
                                </Style.MotionModeSetListSelectFocus>
                            ) : (
                                // 비선택 상태: 기본 스타일
                                <Style.MotionModeSetListSelectUnFocus
                                    onClick={() => onSelect(mode.value)} // 👈 클릭 이벤트 연결
                                >
                                    <Style.MotionModeSetLisUnSelect>
                                        {label}
                                    </Style.MotionModeSetLisUnSelect> 
                                </Style.MotionModeSetListSelectUnFocus>
                            )}
                        </Style.MotionModeSetListSelectFrame>
                    );
                })}

            </Style.MotionModeSetListFrame>

            <br></br><br></br>

            {/* 닫기 버튼 */}
            <Style.MotionModeSetModalButtonFrame>
                <Style.MotionModeSetModalCancleButton
                    onClick={onClose}
                >
                    닫기
                </Style.MotionModeSetModalCancleButton>
            </Style.MotionModeSetModalButtonFrame>

        </Modal>
    );
};

export default ModeSelectionModal;